module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.systemShowed) ? _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [(_vm.systemIndex > 0) ? _c('div', {
    staticClass: "btn-system-change",
    attrs: {
      "id": "prev-system"
    },
    on: {
      "click": _vm.previousSystem
    }
  }) : _vm._e(), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.selectedDevicesID))]), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.selectedDrugInDeviceID))]), _c('div', {
    staticClass: "system-wrapper"
  }, [_c('div', {
    staticClass: "one-system"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "5px"
    }
  }, [_c('strong', [_vm._v("藥櫃編號: " + _vm._s(_vm.systemShowed.relative_index))])]), _c('div', {
    staticClass: "net-wrap"
  }, _vm._l((_vm.systemShowed.net_set), function(net, net_key) {
    return _c('div', {
      class: {
        'one-net': true, 'selected': net_key === (_vm.currentNet.row_id - 1)
      },
      attrs: {
        "id": 'net-' + net_key
      },
      on: {
        "click": function($event) {
          return _vm.selectNet(net)
        }
      }
    }, [_vm._v(_vm._s(net.row_id) + " - " + _vm._s(net.type)), (net.hasDeviceSelected) ? _c('span', {
      staticClass: "device-badge"
    }) : _vm._e(), (_vm.mode === 'onlyDrug') ? _c('span', {
      staticClass: "btn btn-select",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selecteAllDrugStorageWithNet(net)
        }
      }
    }, [_vm._v("選擇整層")]) : _vm._e()])
  }), 0), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRow),
      expression: "showRow"
    }],
    staticClass: "row-model"
  }, [_c('div', {
    staticClass: "model-mask",
    on: {
      "click": function($event) {
        _vm.showRow = !_vm.showRow
      }
    }
  }), _c('div', {
    staticClass: "row-wrap"
  }, [_c('div', {
    staticClass: "row-info"
  }, [_c('span', [_vm._v("第 " + _vm._s(_vm.currentNet.row_id) + " 層")])]), _vm._l((_vm.numRow), function(n) {
    return _c('div', {
      staticClass: "one-net-row",
      style: ({
        'height': 100 / _vm.numRow + '%',
        order: n
      })
    }, _vm._l((_vm.currentNet.device_set), function(device) {
      return (device.pos_row === n || _vm.currentNet.type === 'F') ? _c('div', {
        class: {
          'one-device': true, 'selected-arise': device.selected, 'return-cmpn': device.specific_type === 'return_device', 'lock-cmpn': device.specific_type === 'lock_device', 'lock-cmpn-full': (device.specific_type === 'lock_device' && device.drugstorage_set.length > 0), 'device-in-F': _vm.currentNet.type === 'F'
        },
        style: ({
          'width': (100 * (device.width / 6)) + '%'
        }),
        attrs: {
          "id": ("device-" + (device.pos_row) + "-" + (device.relative_col))
        },
        on: {
          "click": function($event) {
            return _vm.selectDevice(device)
          }
        }
      }, [_c('span', {
        staticClass: "device-position"
      }, [_vm._v(_vm._s(device.pos_row) + " - " + _vm._s(device.relative_col))]), (device.drugstorage_set !== '') ? _c('div', {
        staticClass: "drug-pop"
      }, [(device.specific_type == 'return_device') ? _c('span', [_vm._v("退藥盒")]) : (device.specific_type == 'lock_device') ? _c('span', [_vm._v("保管盒")]) : _vm._l((device.drugstorage_set), function(storage) {
        return _c('div', {
          staticClass: "device-drug",
          class: {
            'selected': storage.selected, 'expired': storage.expired
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.selectDrug(storage)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(storage.medication.code) + " / " + _vm._s(storage.medication.CGMH_number))]), _c('span', [_vm._v(_vm._s(_vm._f("setLength")(storage.medication.generic_name)))]), (storage.expired) ? _c('span', [_vm._v("已過期")]) : _c('span', [_c('small', [_vm._v(_vm._s(storage.expired_date))])])])
      })], 2) : _vm._e(), (device.error) ? _c('div', {
        staticClass: "error-device-mask"
      }, [_c('p', [_vm._v("藥盒已鎖定")])]) : _vm._e()]) : _vm._e()
    }), 0)
  })], 2)])]), _vm._m(0)], 1)]), (_vm.systemIndex + 1 < _vm.systemIds.length) ? _c('div', {
    staticClass: "btn-system-change",
    attrs: {
      "id": "next-system"
    },
    on: {
      "click": _vm.nextSystem
    }
  }) : _vm._e()]) : _c('Loader')
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cabinet-bottom-wrap"
  }, [_c('div', {
    staticClass: "cabinet-bottom float-left"
  }), _c('div', {
    staticClass: "cabinet-bottom float-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-388b976f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/PositionSelection.vue
// module id = 1434
// module chunks = 1